import { render, staticRenderFns } from "./ConferenceSportHealthComp.vue?vue&type=template&id=f7198e38&scoped=true"
import script from "./ConferenceSportHealthComp.vue?vue&type=script&lang=js"
export * from "./ConferenceSportHealthComp.vue?vue&type=script&lang=js"
import style0 from "./ConferenceSportHealthComp.vue?vue&type=style&index=0&id=f7198e38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7198e38",
  null
  
)

/* custom blocks */
import block0 from "./ConferenceSportHealthComp.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports